export const segments = (duration) => {
    const { count, size } = segmentMetadata(duration);
    const segmentsArray = Array.from(Array(count).keys())
        .map(i => ({
            i,
            start: i * size,
            end: Math.min((i + 1) * size, duration),
        }));
    return {
        segmentDuration: size,
        segmentsCount: count,
        segments: segmentArrayToObj(segmentsArray),
    };
};

export const sawnSegments = (segments, chunks) => {
    const segmentsArray = segmentObjToArray(segments)
        .filter(segment => !segment.saw)
        .filter(segment => segmentHasBeenSawn(segment, chunks))
        .map(segment => ({ ...segment, saw: true }));
    return segmentArrayToObj(segmentsArray);
};

export const hasBeenSawn = (segments) => {
    const segmentsArray = segmentObjToArray(segments);
    const total = segmentsArray.length;
    const sawn = segmentsArray
        .filter(segment => segment.saw)
        .length;
    return sawn >= VIDEO_SAW_PERCENT * total;
};

const segmentMetadata = (duration) => {
    const size = (duration > MAX_SEGMENT_COUNT * SEGMENT_SIZE)
        ? multipleCeil(duration / MAX_SEGMENT_COUNT, SEGMENT_SIZE)
        : SEGMENT_SIZE;

    return {
        size,
        count: Math.ceil(duration / size),
    };
};

const multipleCeil = (val, base = 1) => Math.ceil(val / base) * base;

const MAX_SEGMENT_COUNT = 360;
const SEGMENT_SIZE = 10; // seconds
const SEGMENT_SAW_PERCENT = 0.5;
const VIDEO_SAW_PERCENT = 0.9;

const segmentHasBeenSawn = (segment, chunks) => {
    return chunks
        .filter(chunk => overlaps(segment, chunk))
        .filter(chunk => overlapSize(segment, chunk) >= (SEGMENT_SAW_PERCENT * (segment.end - segment.start)))
        .length > 0;
};

const overlapSize = (rangeA, rangeB) => Math.min(rangeA.end, rangeB.end) - Math.max(rangeA.start, rangeB.start);

const overlaps = (rangeA, rangeB) => contains(rangeA, rangeB.end) || contains(rangeB, rangeA.end);

const contains = (range, point) => point >= range.start && point <= range.end;

const segmentArrayToObj = segments => segments.reduce((result, segment) => ({
    ...result,
    [segment.i]: { ...segment, i: undefined },
}), {});

const segmentObjToArray = segments => Object.values(segments).map((val, i) => ({ ...val, i }));



// WEBPACK FOOTER //
// ./src/utils/video-watch-policy.js